import React, { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import storage from '$lib/storage';

const SignOut = () => {
  const client = useApolloClient();
  useEffect(() => {
    setTimeout(() => {
      storage.clearAuth();
      client.resetStore();
    }, 500);
  }, []);

  return <div> Signing out... </div>;
};

export default SignOut;
